import React from "react";
import { Form, Button } from "react-bootstrap";

const MemeForm = (props) => {
  // const filteredMemes = props.topMemes.filter(meme => meme.box_count < 3);

  return (
    <Form>
      <Form.Group>
        <Form.Label>Select a Meme</Form.Label>
        <Form.Control as="select" onChange={props.select}>
          {props.topMemes.map((meme, index) => {
            return (
              <option key={meme.id} value={index}>
                {meme.name}
              </option>
            );
          })}
        </Form.Control>
      </Form.Group>
      <Form.Group>
        <Form.Label>Top Text</Form.Label>
        <Form.Control
          type="text"
          name="text0"
          placeholder={props.topText}
          onChange={props.handleChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Bottom Text</Form.Label>
        <Form.Control
          type="text"
          name="text1"
          placeholder={props.bottomText}
          onChange={props.handleChange}
        />
      </Form.Group>
      <Button variant="primary" onClick={props.submit}>
        Download
      </Button>
    </Form>
  );
};

export default MemeForm;
